/**
 * getSeverUrl
 */
// // 测试服务器地址
// export const severUrl = "https://testdms.hellokittypark.cn"
// export const redisUrl = "https://testdms.hellokittypark.cn/lottery"
// export const paymentUrl = '../../pages/payment/payment'
// export const gameShareUrl = 'pages/webview/webview?url='
// export const wxUrl = 'pages/webviewLogin/webviewLogin?url='
// export const shareCardUrl = "https://testdms.hellokittypark.cn/card/#/"
// export const shareOnlineUrl = "https://testdms.hellokittypark.cn/#/"
// export const shareTicketUrl = "https://testdms.hellokittypark.cn/ticket/#/"
// export const shareHotelUrl = "https://testdms.hellokittypark.cn/hotel/#/"
// export const shareExchangeUrl = "https://testdms.hellokittypark.cn/exchange/#/"
// export const shareGameUrl = "https://testdms.hellokittypark.cn/game/#/"
// export const shareUrl = "https://testdms.hellokittypark.cn/share.html"

// 正式
export const severUrl = "https://dms.hellokittypark.cn"
export const redisUrl = "https://lottery.hellokittypark.cn/api"
export const paymentUrl = '../../pages/payment/payment'
export const gameShareUrl = 'pages/webview/webview?url='
export const wxUrl = 'pages/webviewLogin/webviewLogin?url='
export const shareCardUrl = "https://dms.hellokittypark.cn/card/#/"
export const shareOnlineUrl = "https://dms.hellokittypark.cn/#/"
export const shareTicketUrl = "https://dms.hellokittypark.cn/ticket/#/"
export const shareHotelUrl = "https://dms.hellokittypark.cn/hotel/#/"
export const shareExchangeUrl = "https://dms.hellokittypark.cn/exchange/#/"
export const shareGameUrl = "https://lottery.hellokittypark.cn/#/"
export const shareUrl = "https://dms.hellokittypark.cn/share.html"


export const webpowerUrl = "https://dmt.hellokittypark.cn"
export const loginUrl = webpowerUrl + "/plugin/testMini/uncard?redirect="+ encodeURIComponent(window.location.href)


// 测试服务器地址
// export const severUrl = " "
// export const shareUrl = "https://192.168.4.94:8443/share.html"
// export const webpowerUrl = "https://192.168.4.94:8443"
// 测试登录地址
// export const loginUrl = webpowerUrl + "/plugin/testMini/uncard?redirect="+ encodeURIComponent(window.location.href)

// 正式服务器
// export const severUrl = "https://dms.hellokittypark.cn"
// export const shareUrl = "https://dms.hellokittypark.cn/share.html"
// export const webpowerUrl = "https://dmt.hellokittypark.cn"
// //正式登录地址
// export const loginUrl = webpowerUrl + "/plugin/mini/uncard?redirect="+ encodeURIComponent(window.location.href)

/**
 * getStoreName
 */
export const storeName = 'OnlineStore'

// storeList for test
export const OnlineStore = 'OnlineStore' // 零售
export const Tickets = 'Tickets' // 门票
export const Windbell = 'Windbell' // 美食  暂时不打包
export const hotel = 'Hotel' // 酒店
export const KCoinStore = 'KCoinStore' // 兑换
export const gift = 'GiftCardStore'   //礼品卡
/**
 * getProdCName
 */
export const prodCatalogId = 'RetailCatalog'

// prodCatalogIdList for test
export const RetailCatalog = 'RetailCatalog' // 零售
export const TicketsCatalog = 'TicketsCatalog' // 门票
export const FoodCatalog = 'FoodCatalog'   // 美食  暂时不打包
export const hotelCatalog = 'HotelCatalog' // 酒店
export const KCoinBrowserRoot = 'KCoinBrowserRoot' // 兑换
export const giftCardCatalog = 'GiftCardCatalog'   //礼品卡
/**
 * getProductRecommend
 */
export const productRecommend = 'ProductRecommend'

/**
 * externalLoginKey 后台的admin user，need connect with webpower
 */
export const loginInfo = {
  userName: 'bizadmin',
  password: 'choicelean'
}

/**
 * 跳转白名单，判断跳转路径是否白名单之内，如果之内不需要判断逻辑
 */
export const whiteList = [
  'ticketComfirm' // 从抽奖优惠券直接跳转到确认订单页面
]



// WEBPACK FOOTER //
// ./src/router/Constant.js